import { createProdutoAutorizadoApi } from "@/contexts/laboratorio/produtoAutorizado/api/produtoAutorizadoApi";
import { ProdutoAutorizado } from "@/contexts/laboratorio/produtoAutorizado/model/ProdutoAutorizado";
import {
  getProdutoAutorizadoSynced,
  produtoAutorizadoAction,
} from "@/contexts/laboratorio/produtoAutorizado/store/produtoAutorizadoSlice";
import { SelectOption } from "@/shared/types/SelectOption";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export function useProdutoAutorizado() {
  const { user } = useAuth();
  const produtoAutorizadoApi = createProdutoAutorizadoApi(user?.access_token);
  const listaProdutosAutorizados = useSelector(getProdutoAutorizadoSynced);
  const appDispatch = useDispatch();
  const { sync } = produtoAutorizadoAction;
  const [produtosOptions, setProdutosOptions] = useState<SelectOption[]>([]);

  const sincronizarProdutosAutorizados = (produtos: ProdutoAutorizado[]) => {
    appDispatch(sync(produtos));
  };

  const getProdutosAutorizadosApi = produtoAutorizadoApi.listAll;

  const getProdutoAutorizadoById = (id: number) => {
    return listaProdutosAutorizados.find((produto) => produto.id === id);
  };

  const getProdutosByEstabelecimento = (estabelecimentoId: number) => {
    const produtos = listaProdutosAutorizados.filter(
      (produto) => produto.estabelecimento?.id === estabelecimentoId
    );
    const options = produtos.map((produto) => ({
      label: produto.produto?.nome ?? "",
      value: produto.id,
    }));

    setProdutosOptions(options);
  };

  return {
    listaProdutosAutorizados,
    sincronizarProdutosAutorizados,
    getProdutosAutorizadosApi,
    produtosOptions,
    getProdutoAutorizadoById,
    getProdutosByEstabelecimento,
  };
}
